import styled from 'styled-components'
import { Button } from 'antd'
import { lighten } from 'polished'

export const FilterButton = styled(Button)`
  && {
    background: #1d7ea3;
    border-color: #1d7ea3;
    color: #fff;

    &:hover,
    &:focus {
      background: ${lighten(0.05, '#1d7ea3')} !important;
      border-color: ${lighten(0.1, '#1d7ea3')} !important;
      color: #fff !important;
    }
  }
`
export const CreateButton = styled(Button)`
  && {
    background: #389e6b;
    border-color: #389e6b;
    color: #fff;

    &:hover,
    &:focus {
      background: ${lighten(0.05, '#389e6b')} !important;
      border-color: ${lighten(0.1, '#389e6b')} !important;
      color: #fff !important;
    }
  }
`

export const ShareLinkButton = styled(Button)`
  && {
    background: #7253a5;
    border-color: #7253a5;
    color: #fff;

    &:hover,
    &:focus {
      background: ${lighten(0.1, '#7253A5')} !important;
      border-color: ${lighten(0.1, '#7253A5')} !important;
      color: #fff !important;
    }
  }
`

export const ShareGhostButton = styled(Button)`
  && {
    border-color: #7253a5;
    color: #7253a5;

    &:hover,
    &:focus {
      border-color: ${lighten(0.1, '#7253A5')} !important;
      color: #7253a5 !important;
    }
  }
`

export const EditButton = styled(Button)`
  && {
    background: #ee7b0d;
    border-color: #ee7b0d;
    color: #fff;

    &:hover,
    &:focus {
      background: ${lighten(0.05, '#EE7B0D')} !important;
      border-color: ${lighten(0.1, '#EE7B0D')} !important;
      color: #fff !important;
    }
  }
`
